import $ from 'jquery'

const $doc = $(document)

function handleLongAccordionToggle(event) {
  event.preventDefault();
  
  let button = $(this);
  let accordionItem = button.closest('.js-accordion-item-long');
  let content = button.parent().next('.accordion__single-item-content');
  
  if (accordionItem.hasClass('active')) {
    // Cerrar acordeón
    button.attr('aria-expanded', 'false');
    content.slideUp('fast');
    accordionItem.removeClass('active');
    
    // Limpiar botones de "show more" al cerrar
    content.find('.show-more-btn').remove();
  } else {
    // Abrir acordeón con funcionalidad limitada
    button.attr('aria-expanded', 'true');
    accordionItem.addClass('active');
    
    // Mostrar el contenido primero
    content.slideDown('fast', function() {
      // Una vez que se muestra, procesar las listas
      processLongLists(content);
    });
  }
}

function processLongLists(content) {
  let lists = content.find('ul');
  
  lists.each(function() {
    let list = $(this);
    let items = list.find('li');
    
    if (items.length > 7) {
      // Ocultar elementos después del 7mo
      items.slice(7).hide().addClass('hidden-accordion-item');
      
      // Agregar botón "show more" si no existe ya
      if (!list.next('.show-more-btn').length) {
        let hiddenCount = items.length - 7;
        let showMoreBtn = $('<button class="show-more-btn">...~ ' + hiddenCount + ' more rows</button>');
        
        showMoreBtn.on('click', function(e) {
          e.preventDefault();
          items.slice(7).show().removeClass('hidden-accordion-item');
          $(this).remove();
        });
        
        list.after(showMoreBtn);
      }
    }
  });
}

// Interceptar clics en acordeones largos ANTES que el handler normal
$doc.on('click', '.js-accordion-item-long .accordion__single-item-title button', handleLongAccordionToggle);

export default function initLongAccordion() {
  // Esta función se puede usar para inicialización adicional si es necesaria
  console.log('Long accordion functionality initialized');
} 